<template>
  <div id="intro-overlay" class="overlay">
    <div id="review-1" class="intro-box">
      <div class="intro-box__wrapper">
        <div class="intro-box__header">
          <h3><i class="fas fa-star"></i> Thank you everyone! <i
            class="fas fa-star"></i></h3>
        </div>

        <div class="intro-box__content">
          <p>Our journey has been amazing working with everyone and cannot
            express our gratitude more for the support and feedback you have
            given. We hope our improvements has helped in making your lives a
            little easier and will continue adding more features overtime.</p>

          <p>We would love to hear how our app has helped your business and for
            the world to know, as well. If you have a quick moment to leave us a
            review on the Shopify app store, your feeback would be very
            appreciated!</p>
        </div>

        <div class="intro-box__footer">
          <a
            :href="'https://' + $store.state.shop.myshopify_domain + '/admin/app_store/redirect?url=https://apps.shopify.com/vendor-consignment?#modal-show=ReviewListingModal'"
            target="_blank" @click="finished(true)">
            <button class="button--wide">
              <i class="fas fa-star"></i> Write a Review
            </button>
          </a>

          <div class="intro-box__skip" @click="finished(false)">maybe later</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      currentStep: 1,
      directStep: null,
      directStepValue: null
    }
  },
  methods: {
    changeStep (next) {
      this.directStep = null

      let i = 1

      if (!next) i = -1

      this.currentStep = this.currentStep + i
    },
    goToStep (step) {
      this.directStep = step
    },
    finished (write) {
      if (this.$store.state.metas.vendor_consignment_review_popup_write === undefined) {
        this.$store.dispatch('createMeta', {
          meta_key: 'vendor_consignment_review_popup_write',
          meta_value: write
        })
      } else {
        this.$store.state.metas.vendor_consignment_review_popup_write.meta_value = write

        this.$store.dispatch(
          'updateMeta',
          this.$store.state.metas.vendor_consignment_review_popup_write
        )
      }

      this.$emit('finished')
    }
  }
}
</script>

<style lang="scss">
@import '../../../styles/mixins';
@import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/reviewPopup.vue